module.exports = __webpack_public_path__ + "img/pmc.b8a8be15.png";